const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* AdiBody 15/10/2026: link "Preferenze cookie" nel footer (sostituisce l'icona fluttuante di Cookiebot).
   Riapre il pannello del consenso con window.Cookiebot.show(), come indicato da Cookiebot. */
(function () {
  function aggiungiLinkCookie() {
    if (document.getElementById('ab-cookie-link')) return;
    var box = document.querySelector('.footer__copyright') || document.querySelector('footer');
    if (!box) return;
    var small = document.createElement('small');
    small.className = 'copyright__content';
    var a = document.createElement('a');
    a.id = 'ab-cookie-link';
    a.href = '#';
    a.textContent = 'Preferenze cookie';
    a.style.textDecoration = 'underline';
    a.addEventListener('click', function (e) {
      e.preventDefault();
      if (window.Cookiebot && typeof window.Cookiebot.show === 'function') window.Cookiebot.show();
    });
    small.appendChild(document.createTextNode(' - '));
    small.appendChild(a);
    box.appendChild(small);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', aggiungiLinkCookie);
  else aggiungiLinkCookie();
})();
